<template>
  <svg
    id="Layer_1"
    data-name="Layer 1"
    width="50"
    height="50"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -5 129.72 115.34"
  >
    <g
      id="labs_icon"
      data-name="labs icon"
    >
      <path
        class="cls-3"
        d="M61.57,19.35C37.57-5.45,23.87,2.45,33.37,35.65c5.4-1.1,11.2-2,17.4-2.5,3.5-5.1,7.1-9.7,10.8-13.8M93.17,57.65c2.6,5.6,4.8,11.1,6.6,16.3,33.4-8.4,33.4-24.2,0-32.6-1.8,5.2-3.9,10.7-6.6,16.3ZM79.37,43.05c-12.8-12.8-34.9-3.7-34.9,14.4,0,6.4,2.5,11.3,6.8,15.1,5.4,4.7,5.2,8.6,5.2,14,0,.7.3,1.4.8,1.9h0c.5.5,1.1.8,1.9.8h11.7c.7,0,1.4-.3,1.9-.8h0c.5-.5.8-1.1.8-1.9,0-5.7-.2-9.1,5.5-14.3,4.1-3.7,6.5-8.6,6.5-14.8-.3-5.6-2.6-10.7-6.2-14.4ZM41.17,48.65c1.4-3.8,3.8-6.6,6.1-10.3-4.4.5-8.5,1.1-12.4,1.9,1.3,3.8,2.8,7.7,4.6,11.7.5-1,1.1-2.2,1.7-3.3ZM44.67,72.75c-1.8-2.4-3.8-6.7-5.3-9.5-1.8,4-3.3,8-4.6,11.7,3.9.8,8.1,1.4,12.4,1.9-.8-1.3-1.7-2.7-2.5-4.1ZM103.67,103.45c-.8,4.5-2.8,8.3-6.3,10.4-5.5,3.2-13.3,1.1-21.8-5,1.2-1.1,2-2.6,2.3-4.3,11.9,8.9,19,7.4,21-1.3.9.3,1.8.5,2.8.5.7,0,1.3-.1,2-.3ZM88.27,67.25c-1.1,2.7-4.1,7-5.7,9.6,4.4-.5,8.5-1.1,12.4-1.9-1.3-3.8-2.8-7.7-4.6-11.7-.7,1.4-1.4,2.7-2.1,4ZM84.47,41.45c2.5,3.1,3.9,6.7,6,10.6,1.8-4,3.3-8,4.6-11.7-3.9-.8-8.1-1.4-12.4-1.9.5.9,1.1,2,1.8,3ZM64.87,32.25c1.5,0,3,.1,4.5.4,1.1,0,2.3.1,3.4.1-2.6-3.6-5.2-6.8-7.9-9.8-2.6,3-5.3,6.3-7.9,9.8,1.1-.1,2.2-.1,3.4-.1,1.5-.3,3-.4,4.5-.4ZM55.87,95.85h18c3.2,0,3.2,4.9,0,4.9h-18c-3.2-.1-3.2-4.9,0-4.9ZM68.37,107.25c-.2,1.3-1.7,2.3-3.5,2.3s-3.3-1-3.5-2.3h-3.4c-3.2,0-3.2-4.9,0-4.9h13.7c3.2,0,3.2,4.9,0,4.9,0,0-3.3,0-3.3,0ZM94.87,5.65c-2.3-1.3-5.1-1.1-8.3.1-.1-1-.4-1.9-1-2.8-.3-.6-.7-1.1-1.2-1.5,16-6.1,24.6,7.3,16.7,35.2,38.2,9.7,38.2,32.2,0,41.9.9,3.1,1.7,6.5,2.2,9.9-.6-.1-1.2-.2-1.8-.2-1.1,0-2.1.2-3.1.6l-.1-.7c-.5-2.7-1.2-5.6-2-8.6-5.4,1.1-11.2,2-17.4,2.5-.3.4-.5.8-.8,1.1,0,3.3.4,6-2.2,8.6-.1,0-1.9,2.2-5.3,2.2h-11.5c-3.4,0-5.3-2.2-5.3-2.2-3.3-3.3-1.9-7.7-2.2-8.6-.3-.4-.5-.8-.8-1.1-6.2-.5-12-1.4-17.4-2.5-2.8,9.9-5.5,25.9,1.5,29.9,3.9,2.2,10,.2,17.1-5.1.3,1.7,1.1,3.2,2.3,4.3-19.9,14.2-32.3,4.1-27.7-21.4.5-2.8,1.2-5.8,2.1-8.9-2.8-.7-5.5-1.5-7.9-2.4.3-.3.5-.6.7-1,.6-1.1,1-2.3,1-3.5,2.3.8,4.8,1.5,7.6,2.2,1.7-5.2,3.9-10.7,6.6-16.3-2.6-5.6-4.8-11.1-6.6-16.3C6.07,47.05-.73,56.95,9.87,65.15c-.7.6-1.3,1.3-1.7,2.1-.4.6-.6,1.3-.8,1.9C-7.23,58.55-.13,43.95,28.57,36.75,17.87-1.15,37.47-12.45,64.87,15.75c2.3-2.4,4.6-4.5,6.8-6.4.2.4.4.9.6,1.3.6,1.1,1.4,1.9,2.4,2.6-2.4,2-4.7,4.1-6.5,6,3.6,4.1,7.3,8.7,10.8,13.8,6.2.5,12,1.4,17.4,2.5,2.8-9.8,5.5-25.8-1.5-29.9Z"
      />
      <path
        class="cls-2"
        d="M19.27,73.95c-1.4,2.5-4.6,3.4-7.1,1.9-2.5-1.4-3.4-4.6-1.9-7.1,1.4-2.5,4.6-3.4,7.1-1.9,2.4,1.4,3.3,4.6,1.9,7.1M101.67,90.85c2.9,0,5.2,2.3,5.2,5.2s-2.3,5.2-5.2,5.2-5.2-2.3-5.2-5.2c-.1-2.9,2.3-5.2,5.2-5.2ZM74.47,9.45c-1.4-2.5-.6-5.7,1.9-7.1s5.7-.6,7.1,1.9.6,5.7-1.9,7.1c-2.5,1.5-5.7.6-7.1-1.9Z"
      />
      <path
        class="cls-1"
        d="M75.47,70.35c.3-.3.6-.5.9-.8,3.6-3.2,5.3-7.2,5.3-12.1,0-4.4-1.7-8.7-4.9-11.8-7.7-7.7-19.6-5.7-25.3,1.9,6.2-5,15.8-5.4,22.3,1.1,3.1,3.1,4.9,7.4,4.9,11.8,0,3.9-1,7.1-3.2,9.9Z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'LabsIcon',
};
</script>

<style scoped lang="scss">
.cls-1 {
  isolation: isolate;
  opacity: .25;
}

.cls-1, .cls-2 {
  fill-rule: evenodd;
}

.cls-1, .cls-2, .cls-3 {
  stroke-width: 0px;
}

.cls-1, .cls-3 {
  fill: main.$npGray;
}
.cls-2 {
  fill: #ee8922;
}
.cls-1 {
  isolation: isolate;
  opacity: .25;
}
.cls-1, .cls-2 {
  fill-rule: evenodd;
}
.cls-1, .cls-2, .cls-3 {
  stroke-width: 0px;
}
.cls-1, .cls-3 {
  fill: main.$npGray;
}
.cls-2 {
  fill: #ee8922;
}
</style>
